<template src="./index.html" />
<script>
/* eslint-disable vue/require-prop-types */
export default {
  name: 'AvatarImage',
  props: {
    avatar: {
      default: null,
    },
    size: {
      default: 66,
    },
    color: {
      default: '67BED3',
    },
    position: {
      default: 'center',
    },
  },
  computed: {
    setIconSize() {
      return Number(this.size) + 5;
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
